module.exports = __webpack_public_path__ + "static/media/lego2.71a55740.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lego2.png
// module id = 289
// module chunks = 0